import type { AuthSession } from "../../domain/entities/auth"
import type { AuthModel } from "../models/auth-model"

export const toAuthSession = (
  model: AuthModel,
  email: string
): AuthSession => ({
  accessToken: model.accessToken,
  refreshToken: model.refreshToken,
  email,
})
